import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/fardella1692.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>S&#228;mtliche schriften und briefe series II, volume 2</var><br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		pp 593-594<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: mid-October 1692<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (179k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Michelangelo Fardella (mid-October 1692)</title>
            <meta name="description" content="An English translation of a LETTER TO MICHELANGELO FARDELLA by Gottfried Wilhelm Leibniz, from mid-October 1692" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO MICHELANGELO FARDELLA</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A II 2, 593</b>]<br /><br /> 
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;... You easily understand that the questions you ask about the origin of the soul, the nature of eternal truths, and the principle of motion cannot be adequately explained in a few words, since they involve almost the whole of inner philosophy. Nevertheless, I shall briefly say, for your sake, what seems more true to me.<br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;If propagation occurs through the division of parts, then it is certain that soul cannot be propagated from soul in that way, since it consists in something indivisible. But if you have in mind another basis of propagation, then a precise description of it should be provided, from which it will be readily apparent whether it can apply to the soul.<br /><br />

                 [<b>A II 2, 594</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The ideas of created things result from the idea of God, just as the idea of numbers results from the idea of unity. By that very fact, then, when God understands himself, he comprehends all possibles in his mind, nor is there greater scope for freedom in this than in the derivation of numbers from the repetition of unity, nor is the idea of a circle more arbitrary than that of twoness or threeness. I therefore agree with the scholastics that the existence of creatures is contingent, but that their essences are not; as for those who think otherwise, I hear their words but cannot grasp their meaning. You rightly say that God is sufficient unto himself, so that he is supremely wise and happy; but it must be understood that the essences of creatures are nothing other than various expressions of the divine perfection, and if God did not understand them, he would not sufficiently understand himself. Every free decree arises from deliberation, that is, from the intellect, and deliberations in God's case are distinguished not temporally, but logically, and it is prior by nature to understand than to will. But I no more believe that God could suspend his own knowledge with respect to certain creatures than he could set limits to his own perfection; or even that he could know numbers only up to a thousand and no further. Whatever God will know or understand, he has always known and always understood...
                <br /><br /><br />
                &#169; Lloyd Strickland 2009. Revised 2025<br />
                With gratitude to John Thorley for advice and suggestions
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
